import { Injectable } from '@angular/core';
import { BaseScrollingComponent } from './base-scrolling-component';

// NOTE: this is only a concrete representation of the BaseScrollingComponent.
// It is created solely so we can Inject the implementations on BaseScrollingComponent to a Directive.
// Or simply so we can inject BaseScrollingComponent.
// There should be no changes on this unless the BaseScrollingComponent will have a new abstract function that needs
// implementation.

@Injectable()
export class ConcreteBaseScrollingComponent extends BaseScrollingComponent{

}